import { createRequest } from '../../hub/request';
import { RequestData, RequestDTO } from '../../../../contract/dtos';
import { MutationSchema } from '../types';

// Export the mutation for creating a new request
export const requestMutations = {
  create: (): MutationSchema<RequestData, RequestDTO> => ({
    mutationKey: ['request', 'create'],
    mutationFn: async (requestData: RequestData) => {
      return await createRequest(requestData);
    }
  })
};

